// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1293":"8cf49ba3","4917":"f90e11f0","6569":"ccf27083"}[chunkId] + ".chunk.css";
};